var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheckSolidBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1694_649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C3.60322 14.2098 5.51088 15 7.5 15ZM10.8105 6.12305L7.06055 9.87305C6.78516 10.1484 6.33984 10.1484 6.06738 9.87305L4.19238 7.99805C3.91699 7.72266 3.91699 7.27734 4.19238 7.00488C4.46777 6.73242 4.91309 6.72949 5.18555 7.00488L6.5625 8.38184L9.81445 5.12695C10.0898 4.85156 10.5352 4.85156 10.8076 5.12695C11.0801 5.40234 11.083 5.84766 10.8076 6.12012L10.8105 6.12305Z",
    fill: "#1F57A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1694_649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckSolidBlue);
export default __webpack_public_path__ + "static/media/circle-check-solid-blue.f555db5771c6277808816082fcf8f1b4.svg";
export { ForwardRef as ReactComponent };